import { NewTable } from '../../../comps/NewTable'
import { getCustomColumnWidth, useWindowDimensions } from '../../../util/util'
import data from './listData.json'

const headerRowKeys = {
  Events: 'Events',
  url: 'URL',
  CreationDate: 'Creation Date',
  ModifiedDate: 'Modified Date',
  transactionStatus: 'Status',
}
const WebhooksTab = ({ onListItemClick }: any) => {
  const viewPortWidth = useWindowDimensions()
  return (
    <NewTable
      data={data}
      rowHeight={48}
      headerHeight={64}
      customWidthFunc={getCustomColumnWidth}
      tableWidth={viewPortWidth > 1200 ? viewPortWidth - 290 : viewPortWidth}
      headerRowKeys={headerRowKeys}
      onRowClick={onListItemClick}
    />
  )
}

export { WebhooksTab }
